import { render, staticRenderFns } from "./SetSlatCategory.vue?vue&type=template&id=543b2070&scoped=true&"
import script from "./SetSlatCategory.vue?vue&type=script&lang=js&"
export * from "./SetSlatCategory.vue?vue&type=script&lang=js&"
import style0 from "./SetSlatCategory.vue?vue&type=style&index=0&id=543b2070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543b2070",
  null
  
)

export default component.exports